<template src="./main.html"></template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ToolBar from "@/components/layout/ToolBar";
import LeftBar from "@/components/layout/LeftBar";

export default {
  name: "MainPage",
  components: {
    ToolBar,
    LeftBar,
  },
  setup() {
    const store = useStore();

    // Reactive state
    const menu = ref([]);
    const disabilitaBtn = ref(false);
    const drawer = ref(true);

    // Computed properties
    const loading = computed(() => store.state.app.loading);
    const utente = computed(() => store.getters["user/getNome"]);
    const mail = computed(() => store.getters["user/getMail"]);

    // Methods
    const init = async () => {
      try {
        // User info
        const res = await store.dispatch("user/userInfo");
        menu.value = res.data.menu;
      } catch (error) {
        console.log(error);
      }
    };

    const esci = async () => {
      disabilitaBtn.value = true;
      try {
        await store.dispatch("auth/logout");
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      init();
    });

    return {
      menu,
      disabilitaBtn,
      loading,
      utente,
      mail,
      drawer,
      init,
      esci,
    };
  },
};
</script>